import React from "react";
import { LocationWholegood } from "../../models/features/Integration/DmsSetup";
import {
  useGetDMSManufacturersBySetupIdQuery,
  useGetDmsWholegoodsV2Mutation,
} from "../../redux/reducer/features/Integration/DmsSetupSlice";
import { AppFilter } from "../../models/app/AppModels";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { DmsWhlegoodRequestDto } from "../../models/features/ShoppingPortal/DmsPart";
import {
  GridColDef,
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import {
  Chip,
  Container,
  FormControl,
  InputLabel,
  NativeSelect,
  Typography,
} from "@mui/material";
import ServerAppGrid from "../../compenents/app/ServerAppGrid";
import { AppGridId } from "../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../services/utilities/utility";

const DmsProductsPage: React.FunctionComponent = () => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.DMS_Products
    )
  );
  const Locations = useSelector(
    (state: AppState) => state.authReducer?.dmsSetup?.dmsLocations
  );
  const setupId = useSelector((state: AppState) => state.authReducer.setupId);
  const { data, refetch, isSuccess, isLoading } =
    useGetDMSManufacturersBySetupIdQuery({ setupId: setupId ?? "" });
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 100,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [dmsWhoolgoodsMutation, dmsWhoolgoodsMutationResult] =
    useGetDmsWholegoodsV2Mutation();
  const [wholegoods, setWholegoods] = React.useState<LocationWholegood[]>([]);
  const [dealerIds, setDealerIds] = React.useState<string[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const fetchData = () => {
    if (dealerIds.length > 0) {
      let dmsManufacturersList: string[] = [];
      const manufacturerFilter = paging.items.find(
        (item) =>
          item.columnField === "manufacturer" && item.value !== undefined
      );

      if (manufacturerFilter?.value) {
        dmsManufacturersList.push(manufacturerFilter.value);
      }
      let request: DmsWhlegoodRequestDto = {
        dealerIds: dealerIds,
        search: paging.quickFilterValues.join(" "),
        pageNumber: paging.pageIndex,
        pageSize: paging.pageSize,
        searchModels: [],
        stockingOnly: true,
        wildCardSearch: true,
        searchManufacturerIds: dmsManufacturersList,
      };
      dmsWhoolgoodsMutation({ data: request });
    }
  };

  React.useEffect(() => {
    if (Locations && Locations.length > 0) {
      let ids = Locations.map((item) => item.dealerId.toString());
      setDealerIds(ids);
    }
  }, [Locations]);

  React.useEffect(() => {
    fetchData();
  }, [paging, dealerIds]);

  React.useEffect(() => {
    if (
      dmsWhoolgoodsMutationResult.data &&
      dmsWhoolgoodsMutationResult.isSuccess
    ) {
      let totalRecords = dmsWhoolgoodsMutationResult.data.totalRecords;
      setWholegoods(dmsWhoolgoodsMutationResult.data.entityList);
      setProductsCount(totalRecords);
    }
  }, [dmsWhoolgoodsMutationResult]);
  function CustomFilterInputValue(props: GridFilterInputValueProps) {
    const { item, applyValue } = props;

    const ratingRef: React.Ref<any> = React.useRef(null);

    const handleDropdownFilterChange = (event: any) => {
      applyValue({
        ...item,
        value: event.target.value !== "all" ? event.target.value : undefined,
      });
    };
    return (
      <FormControl fullWidth>
        <InputLabel variant="standard" htmlFor="uncontrolled-native">
          Manufacturer
        </InputLabel>
        <NativeSelect
          ref={ratingRef}
          value={item.value ? item.value : "all"}
          defaultValue="all"
          onChange={handleDropdownFilterChange}
        >
          <option value={"all"}>All</option>
          {data?.entityList
            ? data?.entityList.map((n) => (
                <option value={n.manufacturerId}>{n.name}</option>
              ))
            : null}
        </NativeSelect>
      </FormControl>
    );
  }
  const customFilterOperators: GridFilterOperator[] = [
    {
      label: "Equals",
      value: "equals",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (
          !filterItem.columnField ||
          !filterItem.value ||
          !filterItem.operatorValue
        ) {
          return null;
        }

        return (params): boolean => {
          return params.value == filterItem.value;
        };
      },
      InputComponent: CustomFilterInputValue,
    },
  ];
  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      filterOperators: customFilterOperators,
      valueGetter: (params: GridValueGetterParams<LocationWholegood>) =>
        params.row.mfrCode + " - " + params.row.mfgName,
    },
    {
      field: "model",
      headerName: "DMS Model",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.model,
    },
    {
      field: "productLine",
      headerName: "DMS Category",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.productLine,
    },
    {
      field: "subProduct",
      headerName: "DMS Sub-Category",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.subProduct,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.description,
    },
    {
      field: "price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      type: "number",
      filterable: false,
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "stockItem",
      headerName: "Stocking Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.stockItem ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "locationCount",
      headerName: "In Store",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row?.locationCount) {
          return params.row?.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        } else {
          return 0;
        }
      },
    },
  ];

  return (
    <>
      <Container maxWidth={false}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          DMS Products
        </Typography>

        <ServerAppGrid
          gridId={AppGridId.DMS_Products}
          data={wholegoods.map((n, i) => ({ id: i, ...n }))}
          columns={GetAppGridColumns(
            columns,
            gridSetting?.columnVisibilityModel
          )}
          isLoading={dmsWhoolgoodsMutationResult.isLoading}
          paging={paging}
          setPaging={setPaging}
          totalRecords={productsCount}
          hideCheckBoxes={true}
          height={"77vh"}
        />
      </Container>
    </>
  );
};

export default DmsProductsPage;
